import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetch, fetchLocalAgent } from "../../actions";
import { InputNumberPadrao, LabelPadrao, LoadingContainerPadrao, ModalPadrao } from "../../components/Base";
import { BtnPadrao, BtnSair } from "../../components/Buttons";
import { Result } from "antd";
import { useSave } from "../../components/Hooks/Conexao";
import DanfeViewer from "../Venda/NotaFiscal/DanfeViewer";
import ImpressaoVenda from "./ImpressaoVenda";
import Mensagens from "../../components/Mensagens";
import { imprimirRetorno } from "../../Utils/impressaoUtils";

function ImpressaoVendaOpcional({ id, vias, onCancel, onOk, ...props }) {
  const [dadosDanfe, setDadosDanfe] = useState(null);
  const [idVendaImpressao, setIdVendaImpressao] = useState(null);
  const [viasInterna, setViasInterna] = useState(null);
  const [loadingImpressao, setLoadingImpressao] = useState(false);

  useEffect(() => {
    setViasInterna(vias);

    setTimeout(() => {
      let d = document.getElementById("btnsairmodalimpressaovenda");
      if (!!d)
        d.focus();
    }, 100);

  }, [id]);

  const [imprimir, imprimindo] = useSave(() => props.fetch().post(`venda/imprimir/opcional/${id}/${viasInterna}`), ret => {

    if (ret.isDanfe)
      setDadosDanfe(ret);
    else if (!!ret.vendaId)
      setIdVendaImpressao(ret.vendaId);
    else
      imprimirRetorno(props.fetchLocalAgent, ret, setLoadingImpressao);

    onOk();
  });

  return <>
    <ModalPadrao visible={id} footer={<>
      <BtnPadrao onClick={imprimir} id='btnokmodalimpressaovenda' onKeyDown={e => { if (e.key == 'ArrowRight') document.getElementById("btnsairmodalimpressaovenda").focus(); }}>Imprimir</BtnPadrao>
      <BtnSair onClick={onCancel} id='btnsairmodalimpressaovenda' onKeyDown={e => { if (e.key == 'ArrowLeft') document.getElementById("btnokmodalimpressaovenda").focus(); }} />
    </>} width={500} onCancel={onCancel}>
      <LoadingContainerPadrao loading={imprimindo || loadingImpressao}>
        <Result style={{ margin: 0, padding: 0, paddingTop: 20 }} status="info" />
        <LabelPadrao style={{ textAlign: "center" }}>Deseja realizar a impressão?</LabelPadrao>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div>
            <LabelPadrao style={{ textAlign: "center" }}>Vias</LabelPadrao>
            <InputNumberPadrao precision={0} value={viasInterna} onChange={setViasInterna} min={1} max={3} />
          </div>
        </div>

      </LoadingContainerPadrao>
    </ModalPadrao>

    <DanfeViewer visible={!!dadosDanfe} empresaPk={dadosDanfe?.empresaPk} chave={dadosDanfe?.chaveNfe} onCancel={() => setDadosDanfe(null)} />
    <ImpressaoVenda id={idVendaImpressao} onCancel={() => setIdVendaImpressao(null)} />
  </>;
}

const mapStateToProps = state => ({ empresa: state.auth.empresa });

export default connect(mapStateToProps, { fetch, fetchLocalAgent })(ImpressaoVendaOpcional);